import { render, staticRenderFns } from "./WFTransNode.vue?vue&type=template&id=56d041b5&scoped=true"
import script from "./WFTransNode.vue?vue&type=script&lang=js"
export * from "./WFTransNode.vue?vue&type=script&lang=js"
import style0 from "./WFTransNode.vue?vue&type=style&index=0&id=56d041b5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d041b5",
  null
  
)

export default component.exports